import { all } from 'redux-saga/effects';

import paperworkSaga from './paperwork-saga';

export default function* rootSaga() {
  yield all([paperworkSaga()]);
}
